import axios from "axios";
import React, { useEffect, useState } from "react";

function RequestServices() {
  const [showPopup, setShowPopup] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [search, setSearch] = useState('');

  // Fetch services data
  const getAddress = async () => {
    // const token =  localStorage.getItem('token');
    const token = "8581ab59d19b8b55ea824a9bd9406ffb27add3e3";
    try {
      const response = await axios.get('https://api.avyayam.in/api/v1/product/services/?page=1&page_size=10', {
        headers: {
          accept: 'application/json',
          Authorization: `Token ${token}`
        }
      });
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      console.log("first", response.data.results);
      setFilteredData(response.data.results);
    } catch (error) {
      console.error('Error fetching address:', error);
    }
  }

  React.useEffect(() => {
    getAddress();
  }, []);

  const onChangeSearch = (e) => {
    const value = e.target.value;
    setSearch(value);

    if (value === '') {
      setFilteredData(allData);
    } else {
      const filtered = allData.filter(
        (item) =>
          item.category_name?.toLowerCase().includes(value.toLowerCase()) ||
          item.type?.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredData(filtered);
    }
  };

  const handleFilterSearch = () => {
    const filtered = allData.filter(
      (item) =>
        item.category_name?.toLowerCase().includes(search.toLowerCase()) ||
        item.type?.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const onHandleShowPopup = (item, index) => {
    setSelectedIndex(item);
    setShowPopup(true);
  };

  return (
    <div>
      <div className="flex flex-row w-full">
        <div className="flex justify-center my-4">
          <input
            type="search"
            className="p-2 pl-10 w-full appearance-none rounded text-sm text-gray-700"
            placeholder="Search by category or type"
            value={search}
            onChange={onChangeSearch}
          />
        </div>
        <div className="flex justify-center pl-2 my-4">
          <button
            className="bg-[#219d8e] hover:bg-[#219d8e] text-white font-bold py-2 px-4 rounded-lg"
            onClick={handleFilterSearch}
          >
            Search
          </button>
        </div>
      </div>

      <div className="overflow-x-auto relative shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="px-6 py-3">Name</th>
              <th scope="col" className="px-6 py-3">Specility</th>
              <th scope="col" className="px-6 py-3">Description</th>
              <th scope="col" className="px-6 py-3">Service Type</th>
              <th scope="col" className="px-6 py-3">Location</th>
              <th scope="col" className="px-6 py-3">Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((item, index) => (
                <tr
                  key={index}
                  className="bg-gray-100 dark:bg-gray-700 border-b dark:bg-gray-800 dark:border-gray-700"
                >
                  <td className="px-6 py-4">{item.category_name || 'N/A'}</td>
                  <td className="px-6 py-4">{item.speciality || item.provider_name || 'N/A'}</td>
                  <td className="px-6 py-4">{item.description || 'N/A'}</td>
                  <td className="px-6 py-4">{item.type || 'N/A'}</td>
                  <td className="px-6 py-4">{item.location || 'N/A'}</td>
                  <td className="px-6 py-4">
                    <span
                      className="text-blue-500 hover:text-blue-700 text-white font-bold rounded cursor-pointer"
                      onClick={() => onHandleShowPopup(item, index)}
                    >
                      View
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center py-6 text-gray-500">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {showPopup && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full">
          <div className="relative top-1/2 transform -translate-y-1/2 mx-auto p-5 border w-96 bg-white rounded-md shadow-lg">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-semibold">
                {selectedIndex?.category_name}
              </h3>
              <button
                className="text-gray-600 hover:text-gray-900"
                onClick={() => setShowPopup(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <p className="mt-2">{selectedIndex?.description || 'No Description'}</p>
            <p className="mt-2">{selectedIndex?.type || 'No Type'}</p>
            <p className="mt-2">{selectedIndex?.location || 'No Location'}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default RequestServices;
